const sections = document.querySelectorAll('section.tabs');

sections.forEach((section) => {
	const tabs = section.querySelectorAll('button[role="tab"]');
	const panels = section.querySelectorAll('[role="tabpanel"]');
	const shadowPanels = section.querySelectorAll('[role="tabpanel"][inert]');

	function set(tab) {
		const id = tab.getAttribute('id');
		const panel = section.querySelector(`[role="tabpanel"][aria-labelledby="${id}"]`);

		if (!panel) {
			return false;
		}

		tabs.forEach((_tab) => {
			if (tab.isEqualNode(_tab)) {
				_tab.setAttribute('aria-selected', 'true');
			} else {
				_tab.setAttribute('aria-selected', 'false');
			}
		});

		panels.forEach((_panel) => {
			if (panel.getAttribute('id') === _panel.getAttribute('id')) {
				_panel.classList.add('active');
			} else {
				_panel.classList.remove('active');
			}
		});

		shadowPanels.forEach((shadowPanel) => {
			if (panel.getAttribute('id') === shadowPanel.getAttribute('id')) {
				shadowPanel.removeAttribute('hidden');
			} else {
				shadowPanel.setAttribute('hidden', '');
			}
		});
	}

	tabs.forEach((tab) => {
		tab.addEventListener('click', () => set(tab));
	});
});
